enum NowInNewStateVariants {
  IN_ACTIVE = 'inActive',
  IN_UPCOMING = 'inUpcoming'
}
export default NowInNewStateVariants;
